import { t } from 'i18next';
import { materialStateEnum } from '../enums/material';

export const materialStateEnumLabels: Record<number, string> = {
    [materialStateEnum.NEW]: 'new',
    [materialStateEnum.PRESENT]: 'present',
    [materialStateEnum.REMOVE]: 'remove',
};

export const getMaterialStateLabel = (state?: number): string => {
    return state !== undefined && materialStateEnumLabels[state] ? t(materialStateEnumLabels[state]) : '';
};
